const projects = [
  {
    id: 1,
    name: "Expert Profile",
    description:
      "A responsive web application for the experts to manage their consultations, projects, payments and personal information",
    technologies: "React, Redux, Material UI, HTML, CSS, Javascript, Axios",
    codeURL: "",
    liveURL: "https://expert.eond.eu/",
  },
  {
    id: 2,
    name: "WorkMate",
    description:
      "A responsive web application for helping people to find remote jobs all over the world",
    technologies: "React, Redux, React Suite, HTML, CSS, Javascript, Axios",
    codeURL: "https://github.com/11kaustubhpadwal/workmate-frontend",
    liveURL: "https://workmate.surge.sh/",
  },
  {
    id: 3,
    name: "Basketball Stats",
    description:
      "A responsive web application which is a condensed version of the official NBA stats for basketball fans",
    technologies: "React, Redux, Base Web UI, HTML, CSS, Javascript, Axios",
    codeURL: "https://github.com/11kaustubhpadwal/basketball-stats",
    liveURL: "https://basket-ball-stats.netlify.app/",
  },
  {
    id: 4,
    name: "Get Laundered",
    description: "A responsive web application which is a MVP for a startup",
    technologies: "React, Redux, Material UI, HTML, CSS, Javascript, Axios",
    codeURL: "https://github.com/11kaustubhpadwal/get-laundered-frontend",
    liveURL: "https://get-laundered.vercel.app/",
  },
  {
    id: 5,
    name: "Landing Page",
    description:
      "A responsive landing page created for a MNC as a recruitment task",
    technologies: "HTML, CSS, Javascript",
    codeURL: "https://github.com/11kaustubhpadwal/responsive-website",
    liveURL: "https://responsive-website-task.netlify.app/",
  },
  {
    id: 6,
    name: "Kancelaria",
    description:
      "A responsive website created for a legal advisor to showcase his services and information about laws, rules and regulations in Poland",
    technologies: "HTML, CSS, Javascript, Express.js, Bootstrap 4, EJS",
    codeURL: "",
    liveURL: "http://kancelaria-website.herokuapp.com/",
  },
  {
    id: 7,
    name: "Weather App",
    description:
      "A web application created for a MNC as a recruitment task (it shows weather for any city in the world)",
    technologies: "HTML, CSS, Javascript, React",
    codeURL: "https://github.com/11kaustubhpadwal/weather-app",
    liveURL: "https://my-weather-buddy.netlify.app/",
  },
  {
    id: 8,
    name: "Print-Tex",
    description:
      "A prototype for an e-commerce website which allows anyone to buy textiles in bulk",
    technologies: "Next.js, Redux, HTML, CSS, Javascript",
    codeURL: "https://github.com/11kaustubhpadwal/e-commerce-website",
    liveURL: "https://print-tex.vercel.app/",
  },
];

export default projects;
